import { formatDollar } from 'helpers/formatters';

export const columnDefs = [
    {
        headerName: 'Account',
        field: 'controlAccountDisplay',
        cellStyle: { textAlign: 'left' },
    },
    {
        headerName: 'Total',
        field: 'controlAccountValue',
        type: 'numericColumn',
        valueGetter: (params: any) => formatDollar(params.data.controlAccountValue),
    },
];
